import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Currency } from '../../shared/models/currency';
import { CurrencyModalComponent } from '../modal/currency-modal/currency-modal.component';
import { GenericEvent } from '../../models/genericEvent';
import { AppSettingsService } from '../../services/app-settings/app-settings.service';
import { UpaService } from '../../services/upa/upa.service';
import { CurrencyService } from 'src/app/services/currency/currency.service';
import { EventEmitterService } from '../../services/event-emitter/event-emitter.service';

@Component({
    selector: 'currency-filter',
    templateUrl: './currency-filter.component.html',
    styleUrls: ['./currency-filter.component.scss'],
})
export class CurrencyFilterComponent {
    @Input() currencies: Currency[];
    modalChanged: boolean = false;
    showModal: boolean = false;

    @ViewChild(CurrencyModalComponent, { static: true })
    currencyModal: CurrencyModalComponent;

    constructor(
        private readonly appSettingsService: AppSettingsService,
        private readonly upaService: UpaService,
        private readonly currencyService: CurrencyService,
        private readonly eventEmitterService: EventEmitterService
    ) {}


    changeCurrency(event) {
        let currencyValue = event.target.value;
        this.setSelectedCurrency(currencyValue);
        this.trackUpaCurrencyEvt();
    }

    setSelectedCurrency(currencyValue: string) {
        this.currencyService.changeSelectedCurrencyAndSaveSelection(currencyValue);
        this.eventEmitterService.emitEventChangeCurrency();
    }

    get selectedCurrency() {
       return this.currencyService.getSelectedCurrency();
    }

    private trackUpaCurrencyEvt(): void {
        this.upaService.track(
            GenericEvent.newUserAction('changeCurrency', 'click', {
                channel: this.appSettingsService.getChannel(),
                site: this.appSettingsService.getSite(),
                lang: this.appSettingsService.getLanguage(),
                userId: this.appSettingsService.getUserId(),
            })
        );
    }
}
